import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRadiusBottomRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.85 19.601h3.304a9.25 9.25 0 0 0 9.25-9.25V6.846a.75.75 0 0 1 1.5 0v3.505c0 5.938-4.813 10.75-10.75 10.75H7.85a.75.75 0 0 1 0-1.5M4.1 12.096a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1 3.373a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1-7.373a1 1 0 1 1 0-2 1 1 0 0 1 0 2m11-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomRight24);
